module.exports = __webpack_public_path__ + "media/images/allcare-etiqa-banner-mobile-8c1597ae9a826fdf7433ede13efbd178.jpg";